import React, { PureComponent } from "react";
import Levels from "../Levels.js";
import ReactDOM from "react-dom";

import Constants from '../Constants.js';
import Sounds from '../Sounds.js';
import Level from "./Level.js";

import Footer from './Footer.js';
import Header from './Header.js';
import Paywall from './Paywall.js';
import Appwall from './Appwall.js';
import './Menu.css';



class Menu extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            coolmathUnlockedAllLevels: false,
        }

        // Get level elements
        this.getFreeLevels = this.getFreeLevels.bind(this);
        this.getPaidLevels = this.getPaidLevels.bind(this);

        // Show and hide menu
        this.hideMenu = this.hideMenu.bind(this);
        this.showMenu = this.showMenu.bind(this);

        // Selecting a new level
        this.handleLevelSelect = this.handleLevelSelect.bind(this);

        // Checking whether level is unlocked
        this.isUnlocked = this.isUnlocked.bind(this);

        this.menuWrapper = React.createRef();
    }

    // Stop propagation of touchmove on mount
    componentDidMount() {

        // Handle unlocking all levels (Coolmath version)
        if (Constants.coolmathVersion) {
            window.top.unlockAllLevels = () => {
                this.setState({ coolmathUnlockedAllLevels: true });
            }
        }

        ReactDOM.findDOMNode(this).addEventListener('touchmove', (e) => {
            e.stopPropagation();
        }, false);
    }

    isUnlocked(index) {
        const paidLevelsUnlocked = this.props.data.paidLevelsUnlocked && Constants.appVersion;
        // This is the first level
        const isFirstLevel = index === 0;
        // They've beaten this level
        const beatThisLevel = this.props.data.levelsBeat.indexOf(Levels[index].theme) > -1;
        // They've beaten the previous level
        const beatPreviousLevel = !isFirstLevel && (this.props.data.levelsBeat.indexOf(Levels[index - 1].theme) > -1);
        // This level is free
        const isFree = index < Constants.freeLevels;
        // Whether they've paid to unlocked levels and this level is free
        const isFreeAndPaid = isFree && paidLevelsUnlocked;
        // This level is the first paid
        const isFirstPaidLevel = index === Constants.freeLevels;

        // Return whether this level is unlocked
        return (isFirstLevel || beatPreviousLevel || beatThisLevel || isFreeAndPaid || isFirstPaidLevel || this.state.coolmathUnlockedAllLevels) && (isFree || paidLevelsUnlocked);
    }

    // Get free level elements
    getFreeLevels() {
        return Levels.map((level, index) =>
            (index < Constants.freeLevels) &&
            <Level
                key={index}
                level={index}
                onLevelSelect={this.handleLevelSelect}
                // This is the first level, they've beaten this level, or they've beaten the previous level
                unlocked={this.isUnlocked(index)}
            />
        );
    }
    getPaidLevels() {
        return Levels.map((level, index) =>
            (index >= Constants.freeLevels) &&
            <Level
                key={index}
                level={index}
                onLevelSelect={this.handleLevelSelect}
                unlocked={this.isUnlocked(index)}
            />
        );
    }

    // Handle level selection
    handleLevelSelect(level) {
        Sounds.play('tap');
        this.props.onLevelSelect(level);
    }

    // Hide menu
    hideMenu() {
        this.menuWrapper.current.style.transform = 'translateX(-100%)';
    }
    // Show menu
    showMenu() {
        this.menuWrapper.current.style.transform = 'translateX(0)';
    }

    /*
    * Render
    */

    render() {

        return (
            <div
                ref={this.menuWrapper}
                className="MenuWrapper"
                style={{
                    backgroundColor: '#fbfbfb',
                }}
            >
                <Header
                    data={this.props.data}
                    // Either not the app version or the Coolmath version
                    webVersion={(!Constants.appVersion || Constants.coolmathVersion)}
                    onTutorialInit={() => {
                        if (typeof this.props.onTutorialInit === 'function')
                            this.props.onTutorialInit();
                    }}
                    onGetHints={() => {
                        if (typeof this.props.onGetHints === 'function')
                            this.props.onGetHints();
                    }}
                    onRateApp={() => {
                        if (typeof this.props.onRateApp === 'function')
                            this.props.onRateApp();
                    }}
                />
                <div className="LevelWrapper">
                    <div
                        style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: '520px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                        }}
                    >
                        {this.getFreeLevels()}
                        {
                            // Display a paywall if this is the app version and they haven't unlocked all the levels
                            (!this.props.data.paidLevelsUnlocked && Constants.appVersion && !Constants.coolmathVersion) &&
                            <Paywall
                                data={this.props.data}
                                prices={this.props.prices}
                            />
                        }
                        {
                            // Display an appwall if this is the web version
                            (!Constants.appVersion && !Constants.coolmathVersion) &&
                            <Appwall />
                        }
                        {!Constants.coolmathVersion && this.getPaidLevels()}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Menu;
